import { OLIVE_CDN } from '@olive/fonts'

// TODO: this would eventually check context
export const useFontFace = () => OLIVE_CDN
